module.exports = __webpack_public_path__ + "static/media/automation.inactive.00909825.svg";